import { animate, state, style, transition, trigger } from '@angular/animations';
import { formatDate } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { ENTER } from '@angular/cdk/keycodes';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  SimpleChange,
  viewChild,
  ViewChild,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MAT_CHIPS_DEFAULT_OPTIONS, MatChipInputEvent } from '@angular/material/chips';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { MaintenanceModalComponent } from '../shared/maintenance-modal/maintenance-modal.component';
import { CommonModelService } from '../../../padu-reporting/capability/common-model.service';
import { ExportDataService } from '../../../shared/services/export-data.service';
import { MaintenanceService } from '../../services/maintenanceService';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SharedAuthService } from '../../../shared/shared.auth.service';
@Component({
  selector: 'app-maintenance-table-v4',
  templateUrl: './maintenance-table-v4.component.html',
  styleUrls: ['./maintenance-table-v4.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)'))
    ])
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: MAT_CHIPS_DEFAULT_OPTIONS,
      useValue: {
        separatorKeyCodes: [ENTER]
      }
    }
  ],
  standalone: false
})
export class MaintenanceTableV4Component implements OnInit {
  @Input() COLUMNS: any[] = ['Group Name', 'Group Type', 'No Of Applications', 'Visibility', 'Action'];
  @Input() SCHEMA;
  @Input() TABLE_CONFIG;
  @Input() SORT_CONFIG: Sort;
  @Input() expanded_columns: any[] = ['Segment', 'LOB', 'Sub LOB', 'Chief Architect', 'Architect Delegate'];
  @Input() noRowHeight: boolean = false;
  @Input() BulkUpload: boolean = false;
  @Input() isExpandIconAtStart: boolean = false;

  @ViewChild('pagination', { static: false }) StaticPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;
  @ViewChildren('innerTables') innerTables: QueryList<MatTable<any>>;
  @ViewChild('assignLobLeaderPopUp') assignLobLeaderPopUp;
  @ViewChild('assignDecomLobPopUp') assignDecomLobPopUp;
  @ViewChildren('childpagination') childpaginator: QueryList<MatPaginator>;

  @Input() dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() childDataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  @Input() expandAll: string = 'false';
  @Input() exportToExcel: number;
  @Input() selectedOption: string = 'lob';
  @Output() reloadData: EventEmitter<any> = new EventEmitter();
  @Output() reloadEditRoleData: EventEmitter<any> = new EventEmitter();
  @Output() paginationClickEvent: EventEmitter<any> = new EventEmitter();
  @Output() sortChangeEvent: EventEmitter<any> = new EventEmitter();
  @Output() checkClick: EventEmitter<any> = new EventEmitter();
  @Output() saveEvent: EventEmitter<any> = new EventEmitter();
  @Output() CreateEvent: EventEmitter<any> = new EventEmitter();
  @Output() checkBoxEvent: EventEmitter<any> = new EventEmitter();
  @Output() addEvent: EventEmitter<any> = new EventEmitter();
  @Output() removeRecordEvent: EventEmitter<any> = new EventEmitter();
  @Output() cancelRecordEvent: EventEmitter<any> = new EventEmitter();
  @Output() filteredDataCountEvent: EventEmitter<number> = new EventEmitter();
  @Input() pageSize: Array<number>;
  @ViewChild('modalAddLob', { static: false }) modalAddLob;
  private subject: Subject<string> = new Subject();
  private modalClosedSub?: Subscription;
  coltofilter = [];
  currentYear = new Date().getUTCFullYear();
  separatorKeysCodes: number[] = [ENTER];
  editExpandDataSource = [];
  reloadOnReopen: boolean = false;
  displayedColumns: any[] = [];
  displayedChildColumns: any[];
  dataSchema;
  dataFilter;
  originalDataFilter;
  paduapplyFlag: boolean = false;
  clonedData: any;
  selection = new SelectionModel<any>(true, []);
  expandedElement;
  addCapability;
  selectedRow: any[] = [];
  leaderMsid: any;
  expandElements = [];
  @Output() sharedOptumVal = new EventEmitter();
  Allfilter = [];
  AllSubfilter = [];
  SegmentFilter = [];
  decomIdFilter = [];
  decomFilter = [];
  userRoleFilter = [];
  LobFilter = [];
  SubLobFilter = [];
  SubYearFilter = [];
  sblobFilter = [];
  userNameFilter = [];
  sizeFilter: any[] = [];
  multiSRVFilter = [];
  yearFilter = [];
  usersFilter = [];
  serviceFilter = [];
  serviceKeyFilter = [];
  categoryFilter = [];
  SRV_DisableFilter = [];
  Public_Private_CloudFilter = [];
  Complex_ServicesFilter = [];
  UI_CommentsFilter = [];
  App_NonAppFilter = [];
  Edit_TOHFilter = [];
  ChiefArchitectFilter = [];
  ArchitectDelegateFilter = [];
  RoleFilter = [];
  FeatureFilter = [];
  RoleAccessFilter = [];
  SecureGroupFilter = [];
  sblobFilterApplied: boolean = false;
  FeatureFilterApplied: boolean = false;
  RoleAccessFilterApplied: boolean = false;
  SecureGroupFilterApplied: boolean = false;
  isNameFilterApplied: boolean = false;
  sizeFilterApplied: boolean = false;
  multiSRVFilterApplied: boolean = false;
  yearFilterApplied: boolean = false;
  usersFilterApplied: boolean = false;
  serviceFilterApplied: boolean = false;
  serviceKeyFilterApplied: boolean = false;
  categoryFilterApplied: boolean = false;
  SRV_DisableFilterApplied: boolean = false;
  Public_Private_CloudFilterApplied: boolean = false;
  Complex_ServicesFilterApplied: boolean = false;
  UI_CommentsFilterApplied: boolean = false;
  App_NonAppFilterApplied: boolean = false;
  Edit_TOHFilterApplied: boolean = false;
  SegmentFilterApplied = false;
  decomIdFilterApplied = false;
  decomFilterApplied: boolean = false;
  LobFilterApplied = false;
  userRoleFilterApplied: boolean = false;
  RoleFilterApplied: boolean[] = [false];
  SubLobFilterApplied: boolean[] = [false];
  subYearFilterApplied: boolean[] = [false];
  ChiefArchitectFilterApplied: boolean[] = [false];
  ArchitectDelegateFilterApplied: boolean[] = [false];
  AllArchitectDelegates = [];
  filValue = [];
  users: any = [];
  filSubValue = [];
  leaderName: string;
  filterList: any;
  searchValue: string;
  selectedLob: any;
  selectedSubLob: any;
  searchTxt = '';
  searchSubTxt = '';
  inputElement: any;
  olddatasource: any[];
  oldChildDataSource: any[];
  previousSelection = [];
  allRowsExpanded: boolean = false;
  selectedChildTableIndex: number;
  currentFilterColumn: any; // Store current column for menu access
  disableEditSubLob: boolean = true;
  userRole: any;
  showLoader: boolean = false;
  addEditTitle: string = '';
  addEditDecomLOBpopupType: string = '';
  @Input() dataSourceDecomLOBSegments: any[] = [];
  decomSelectedEditRow: any;
  @Output() collapseAll: EventEmitter<any> = new EventEmitter();
  @Output() columnDataSubLob: EventEmitter<any> = new EventEmitter();
  @Output() ColomnDataLob: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();
  @Output() loadDeletePopup: EventEmitter<any> = new EventEmitter();
  @Output() notifyToParentInitiative: EventEmitter<any> = new EventEmitter();
  @Output() updateStatusEvent: EventEmitter<any> = new EventEmitter();
  @Output() downloadClickEvent: EventEmitter<any> = new EventEmitter();
  @Output() getLobMappingDetails = new EventEmitter<void>();
  @ViewChild('deleteModel', { static: false }) deleteModel;
  @ViewChild('editRoleModel', { static: false }) editRoleModel;
  @ViewChild('ruleDtlModel', { static: false }) ruleDtlModel;
  @Input() selectedInitiative: any;
  @Input() isTableRefreshed: boolean = false;
  @Input() pageSizeOptions: number[] = [10, 15, 20];
  editRoleData: any = {};
  newevent: any;
  AddLobDataUpdated = {
    ChiefArchitect: [],
    ArchitectDelegate: []
  };
  existingLeaderIds = [];
  NameFilterApplied: boolean[] = [false];
  NameFilter: any[];
  isSystemAdmin: any = false;
  isAdmin: any = false;
  isRoleInitiative: boolean = false;
  @Input() isResetFilter: boolean = false;
  @Output() editEvent: EventEmitter<any> = new EventEmitter();
  expandedElements: any[] = [];
  displayedColumnsKeys: any[];
  checked = false;
    @Input() isInvalidTable: boolean = false;
  validationQuery: any;
  @Input() isAddDisabledFn: (element: any) => boolean = () => false;

  loggedInUserMsid: string = '';

  private readonly downloadInProgressKeys = new Set<string>();

     @Output() filterApplied = new EventEmitter<{ columnKey: string, selectedValues: any[] }>(); 
      @Output() filterCleared = new EventEmitter<string>(); // Emit when filters are cleared
      @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;
    
  constructor(
    public maintenanceService: MaintenanceService,
    private capabilityService: CommonModelService,
    private toastrService: ToastrService,
    public exportService: ExportDataService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private router: Router,
    private sanitizer: DomSanitizer,
    private toaster: ToastrService,
    private sharedAuthService : SharedAuthService
  ) {
    const currentRoute = (this.router.url).split('/');
    this.isRoleInitiative = currentRoute.includes('initiatives');
    this.addCapability = this.capabilityService.addCapability.subscribe((value: any) => {
      let data = this.dataSource.data;
      data = data.filter(ele => !ele['isNew']);
      data.unshift(value);
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
    });
    this.loggedInUserMsid = sessionStorage.getItem('MsId')
  }

  ngOnInit() {
    this.alphaOrderLeadEAonDataSource();
    this.isSystemAdmin = this.sharedAuthService.checkForRoleAccess('System Admin');
    this.isAdmin = this.sharedAuthService.checkForRoleAccess('Admin'); 

    this.displayedColumns = this.COLUMNS
      .filter(element => element.hasOwnProperty('expand') ? element.expand == false : true)
      .map(element => element.key);

      this.displayedColumnsKeys = [...this.displayedColumns, 'expandedRowDetail']; 


    this.displayedChildColumns = this.expanded_columns.map(element => element.key);
    this.coltofilter = this.COLUMNS.filter(x => x.filter);
    this.inputElement = '';
    this.dataSchema = this.SCHEMA;
    this.selectedRow = [];
    if (this.dataSource) {
      this.olddatasource = this.dataSource.data;
      // If server-side pagination is enabled, the parent is responsible for paging.
      // Attaching a (potentially hidden) MatPaginator here would still slice rows to the default page size (often 10).
      this.dataSource.paginator = this.TABLE_CONFIG?.serverSidePagination ? undefined : this.paginator;
      this.dataSource.sort = this.sort;
      this.clonedData = _.cloneDeep(this.dataSource.data);
    }

    if (this.TABLE_CONFIG) {
      if (this.TABLE_CONFIG.FILTER_OPTIONS) {
        this.dataFilter = this.TABLE_CONFIG.FILTER_OPTIONS;
        this.originalDataFilter = JSON.parse(JSON.stringify(this.TABLE_CONFIG.FILTER_OPTIONS));
      }
    }

    this.subject.pipe(debounceTime(500)).subscribe(searchObj => {
      this.handleSearch(searchObj);
    });

    this.modalClosedSub = this.modalAddLob?.closed?.subscribe(() => {
      this.onModalClosed();
    });
  }

  ngOnDestroy() {
    this.modalClosedSub?.unsubscribe();

    if (typeof this.addCapability != 'undefined') {
      this.addCapability.unsubscribe();
    }
  }

  ngOnChanges(changes: { [expandAll: string]: SimpleChange }) {
    this.existingLeaderIds = [];
    if (changes['expandAll']) {
      if (changes['expandAll']['previousValue']) {
        const change: string = changes['expandAll'].currentValue;
        this.dataSource.data.forEach(element => {
          if (change == 'true') {
            this.allRowsExpanded = true;
            this.expandDetailRow(element, true);
          } else {
            this.allRowsExpanded = false;
            this.expandElements = [];
            this.collapseDetailRow(element);
          }
        });
      }
    }
    if (changes['exportToExcel']) {
      if (changes['exportToExcel']['previousValue']) {
        this.exportToCsv();
      }
    }
    // Always re-attach paginator and sort when dataSource changes
    if (changes['dataSource']) {
      this.handleDataSourceChange();
    }
    if (changes['selectedOption']) {
      if (changes['selectedOption']['currentValue'] == 'lob') {
        this.dataSource.data.forEach((a, i) => {
          if (a.org_name || a.isEdit || a.isNew) this.dataSource.data.splice(i, 1);
        });
        this.dataSource.data = this.dataSource.data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }
    if (this.TABLE_CONFIG['TABLE_CLASS'] == 'optum-tech-labour-split-tble-container') {
      this.existingLeaderIds = this.dataSource.data.map(ele => ele['leader_msid']);
    }
    if (changes['isTableRefreshed']) {
      this.selection.clear();
    }
    if (this.isResetFilter) {
      this.clearallFilter(false);
    }
    if (changes['SORT_CONFIG'] && this.SORT_CONFIG && this.sort) {
      this.sort.active = this.SORT_CONFIG.active;
      this.sort.direction = this.SORT_CONFIG.direction || 'asc';
    }
  }

  ngAfterViewInit() {
    if (this.dataSource && this.dataSource.data.length) {
      this.updateSortOnDataSource();
      this.dataSource.data.forEach((element, index) => {
        if (element.childDataSource) {
          element.childDataSource.paginator = this.childpaginator.toArray()[index];
        }
      });
    }
    this.displayedChildColumns = this.expanded_columns.map(element => element.key);
  }
  handleDataSourceChange() {
    // If parent passes a plain array, wrap it in MatTableDataSource
      if (this.dataSource && Array.isArray(this.dataSource)) {
        this.dataSource = new MatTableDataSource(this.dataSource);
      }
      // If parent passes a MatTableDataSource or after wrapping
      if (this.dataSource) {
        this.dataSource.paginator = this.TABLE_CONFIG?.serverSidePagination ? undefined : this.paginator;
        this.dataSource.sort = this.sort;
        this.olddatasource = this.dataSource.data;
      }
      this.clearallFilter(false);
      if (this.dataSource && this.dataSource.data) {
        this.dataSource.data.forEach((element, index) => {
          if (element.childDataSource) {
            this.alphaOrderLeadEAonDataSource();
            if(this.childpaginator && this.childpaginator.toArray()[index]){
              element.childDataSource.paginator = this.childpaginator.toArray()[index];
            }
          }
        });
      }
      if (this.allRowsExpanded || this.expandElements) {
        if (this.allRowsExpanded) {
          this.toggle();
        } else {
          this.expandElements.forEach(ele => {
            this.expandDetailRow(this.dataSource.data[ele], false);
          });
        }
      }
    }
    
  toggleHead(): void {
    this.allRowsExpanded = !this.allRowsExpanded;

    if (this.allRowsExpanded) {
      this.expandedElements = [...this.dataSource.data];
    } else {
      this.expandedElements = [];
    }
  }

  toggleRow(row: any): void {
    console.log('Toggling row:', row);
    const index = this.expandedElements.indexOf(row);
    if (index === -1) {
      this.expandedElements.push(row);
    } else {
      this.expandedElements.splice(index, 1);
    }
  }



  isRowExpanded(row: any): boolean {
    return this.expandedElements ? this.expandedElements.includes(row) : false
  }

  getUnchangedFields(row: any): string {
    return Array.isArray(row.UnchangedValues) && row.UnchangedValues.length > 0
      ? row.UnchangedValues.join(', ')
      : 'No Unchanged Fields';
  }

  getChangedFields(row: any): any[] {
    if (this.isInvalidTable) {
      if (this.checked) {
        return row.changedValues || [];
      } else {
        // return (row.changedValues || []).filter((item: any) => item.Error);
        return (row.changedValues || []).filter((item: any) => item.Error && item.Error !== '' && item.Error !== 'No Error');
    
      }
    }
    else {
      return row.changedValues || [];
    }
  }

  getFilteredChangedFields(row: any): any[] {
    if (this.checked) {
      return row.changedValues || [];
    } else {
      return (row.changedValues || []).filter((item: any) => item.Error);
    }
  }

 
    applyBulkLocalFilter(column: any) {
      if (column.searchValue?.length > 0) {
        this.filterApplied.emit({ columnKey: column.key, selectedValues: column.searchValue });
      }
      this.menuTrigger.closeMenu(); 
    }
    
    onToggleChange() {
      this.checked != this.checked
    }
  
   
    clearBulkLocalFilter(column: any) {
      column.searchValue = [];
      column.search = '';
      this.filterCleared.emit(column.key);
      this.menuTrigger.closeMenu(); 
    }

  changedOptumEvent(event, element) {
    const rowNewVal = element;
    this.sharedOptumVal.emit([event, rowNewVal]);
  }

  private getDownloadKey(element: any): string {
    const requestId = element?.Request_id ?? element?.RequestId ?? element?.request_id;
    if (requestId !== null && requestId !== undefined && `${requestId}`.trim() !== '') {
      return `req:${requestId}`;
    }

    const blobPath = element?.blobfilepath ?? element?.blobPath ?? '';
    const blobName = element?.blobfilename ?? element?.blobName ?? '';
    const combined = `${blobPath}/${blobName}`.replace(/\/+/, '/').trim();
    if (combined && combined !== '/') {
      return `blob:${combined}`;
    }

    const id = element?.id ?? element?._id;
    if (id !== null && id !== undefined && `${id}`.trim() !== '') {
      return `id:${id}`;
    }

    // last resort (should be rare)
    return `row:${JSON.stringify(element ?? {})}`;
  }

  isDownloadInProgress(element: any): boolean {
    return this.downloadInProgressKeys.has(this.getDownloadKey(element));
  }

  onDownloadClick(element: any) {
    const key = this.getDownloadKey(element);
    if (this.downloadInProgressKeys.has(key)) return;

    this.downloadInProgressKeys.add(key);

    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      this.downloadInProgressKeys.delete(key);
      // Ensure template updates even if download resolves outside Angular zone.
      this.cd.detectChanges();
    };

    // Emit a payload so the parent can call done() in finally.
    this.downloadClickEvent.emit({ row: element, key, done });

    this.toastrService.success('Your file is downloading…', '', {
      timeOut: 3000,
      positionClass: 'toast-top-center'
    });
  }
  onShareClick(element: any) {
          const navigationExtras: any = {
            queryParams: { 'RequestId': element.Request_id,
                            'manageShare' : true ,
                          tab: 'share'}
          };
      
          this.router.navigate([{ outlets: { primary: 'maintenance/editGroup' }}], navigationExtras );       
  }

  // Hover tooltips for status icons are handled via CSS (no mouseenter handlers).

  getStatusTooltipHtml(status?: string): string {
    const normalizedStatus = (status || '').toString().toLowerCase();
    switch (normalizedStatus) {
      case 'completed':
        return 'File is ready. Click the download.';
      case 'failed':
        return 'Failed to generate the file, contact <a href="/contact-us">TechOps</a> team for help.';
      case 'in progress':
        return 'File is being generated, please allow a few minutes and recheck the status.';
      default:
        return '';
    }
  }

  onStatusTooltipClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    const anchor = target?.closest('a') as HTMLAnchorElement | null;
    if (!anchor) return;

    // Prevent table row/cell click handlers from firing.
    event.stopPropagation();

    const href = anchor.getAttribute('href') || '';
    if (href === '/contact-us') {
      event.preventDefault();
      this.router.navigate(['/contact-us']);
    }
  }


  assignLobLeader(element) {
    this.selectedLob = element;
    this.assignLobLeaderPopUp.show();
    this.reloadOnReopen = !this.reloadOnReopen;
  }

  closeAssignLobLeader() {
    this.assignLobLeaderPopUp.hide();
    this.reloadData.emit();
  }
  closeAssignSubLobDecom() {
    this.assignDecomLobPopUp.hide();
    this.reloadData.emit();
  }
  shwRuleDtl(element){
    console.log(element,'ele')
this.ruleDtlModel.show();
this.validationQuery = element.validationQuery
  }

  checkPrevious(event, prevArr: any = []) {
    this.previousSelection = prevArr;
    if (this.previousSelection && this.previousSelection.length > 0) {
      let isPrevValueUnselected = true;
      for (let i = 0; i < this.previousSelection.length; i++) {
        //If previous selection is in DropDownData and not in event then only add previous selection in Event Values(Server Side Search)
        const uncheckedElementName = event.options[0]._value;
        const unchekcedStatus = event.options[0]._selected;
        if (!(unchekcedStatus) && isPrevValueUnselected) { //check for unchecked elements
          if (this.previousSelection[i] == uncheckedElementName) //check for element which is unchecked
          {
            this.previousSelection.splice(i, 1);
            i--;
            isPrevValueUnselected = false;
          }
        } else if (this.filterLists.includes(this.previousSelection[i]) && event.source._value.length > 0
          && !event.source._value.includes(this.previousSelection[i]))  //Checked cond1
        {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    if (event.source._value.length == 0) {//Unchecked cond2: element is unchecked after search
      for (let i = 0; i < this.previousSelection.length; i++) {
        if (this.filterLists.includes(this.previousSelection[i])) {
          event.source._value.push(this.previousSelection[i]);
        }
      }
    }
    this.previousSelection = [... new Set(event.source._value)];
    return event
  }

  selectionChange(event, column) {
      const filterColIndex = this.coltofilter.findIndex(x => x.key === column.key);
  
      const handleFilterChange = (key, filterArray, filterName) => {
          this.Allfilter = this.Allfilter.filter(a => a.column !== filterName);
          const newEvent = this.checkPrevious(event, filterArray);
          if (newEvent.source._value.length > 0) {
              this[filterArray] = newEvent.source._value;
              this.Allfilter.push({ column: filterName, value: newEvent.source._value });
          } else {
              this[filterArray] = [];
          }
          this.trigger.toArray()[filterColIndex].openMenu();
      };
  
      switch (column.key) {
          case 'MasterSegment':
          case 'Master_Segment':
              handleFilterChange(column.key, 'SegmentFilter', column.key);
              break;

          case 'DecomLobID':
              handleFilterChange(column.key, 'decomIdFilter', column.key);
              break;
          case 'MBO_Segment':
              handleFilterChange(column.key, 'SegmentFilter', column.key);
              break;
          case 'MBO_Segment_ID':
              handleFilterChange(column.key, 'decomIdFilter', column.key);
              break;
          case 'DecomLobName':
              handleFilterChange(column.key, 'decomFilter', column.key);
              break;
          case 'CIOLOB':
              handleFilterChange(column.key, 'LobFilter', 'CIOLOB');
              break;
          case 'User_Role':
              handleFilterChange(column.key, 'userRoleFilter', 'User_Role');
              break;
          case 'lob':
              handleFilterChange(column.key, 'LobFilter', 'lob');
              break;
          case 'Sub_LOB':
              handleFilterChange(column.key, 'sblobFilter', 'Sub_LOB');
              break;
          case 'displayName':
              handleFilterChange(column.key, 'userNameFilter', 'displayName');
              break;
            case 'Size':
              handleFilterChange(column.key, 'sizeFilter', 'Size');
              break;
          case 'MULTI_SRV':
              handleFilterChange(column.key, 'multiSRVFilter', 'MULTI_SRV');
              break;
          case 'year':
              handleFilterChange(column.key, 'yearFilter', 'year');
              break;
          case 'SRVDESC':
              handleFilterChange(column.key, 'serviceFilter', 'SRVDESC');
              break;
          case 'Service':
              handleFilterChange(column.key, 'serviceKeyFilter', 'Service');
              break;
          case 'Category':
              handleFilterChange(column.key , 'categoryFilter', 'Category');
              break;
          case 'SRV_Disable':
              handleFilterChange(column.key, 'SRV_DisableFilter', 'SRV_Disable');
              break;
          case 'Public_Private_Cloud':
              handleFilterChange(column.key, 'Public_Private_CloudFilter', 'Public_Private_Cloud');
              break;
          case 'Edit_TOH':
              handleFilterChange(column.key, 'Edit_TOHFilter', 'Edit_TOH');
              break;
          case 'Complex_Services':
              handleFilterChange(column.key, 'Complex_ServicesFilter', 'Complex_Services');
              break;
          case 'UI_Comments':
              handleFilterChange(column.key, 'UI_CommentsFilter', 'UI_Comments');
              break;
          case 'App_NonApp':
              handleFilterChange(column.key, 'App_NonAppFilter', 'App_NonApp');
              break;
          case 'Users':
              handleFilterChange(column.key, 'usersFilter', 'Users');
              break;
          case 'Feature':
              handleFilterChange(column.key, 'FeatureFilter', 'Feature');
              break;
          case 'Role':
              handleFilterChange(column.key, 'RoleAccessFilter', 'Role');
              break;
          case 'Secure_Group':
              handleFilterChange(column.key, 'SecureGroupFilter', 'Secure_Group');
              break;
          default:
              break;
      }
      this.trigger.toArray()[filterColIndex].openMenu();
    }

  selectionleaderChanged(value) {
    this.leaderMsid = value == '' ? null : value.msid;
    this.leaderName = value == '' ? null : value.displayName;
  }

  canShowShareIcon(element){
      const current = (this.loggedInUserMsid || '').toString().trim().toLowerCase();
     

      const rowMsid = (element?.created_by || '').toString().trim().toLowerCase();
      

      return rowMsid === current;
    
  }

  // selectionSubChange(event, column, element) {
  //   let newevent;
  //   element = this.olddatasource[this.selectedChildTableIndex];
  //   if (column.key == 'SubLineofBusiness') {
  //     this.AllSubfilter.forEach((a, i) => {
  //       if (a.column == 'SubLineofBusiness' && element['id'] == a.index) this.AllSubfilter.splice(i, 1);
  //     });
  //     newevent = this.checkPrevious(event,this.SubLobFilter);
  //     if (newevent.source._value.length > 0) {
  //       this.SubLobFilter = newevent.source._value;
  //       this.AllSubfilter.push({ column: 'SubLineofBusiness', value: newevent.source._value, index: element['id'] });
  //     } else {
  //       this.SubLobFilter = [];
  //     }
  //     this.trigger.toArray()[2].openMenu();
  //   }

  //   if (column.key == 'Sub_LOB') {
  //     this.AllSubfilter.forEach((a, i) => {
  //       if (a.column == 'Sub_LOB' && element['id'] == a.index) this.AllSubfilter.splice(i, 1);
  //     });
  //     newevent = this.checkPrevious(event,this.SubLobFilter);
  //     if (newevent.source._value.length > 0) {
  //       this.SubLobFilter = newevent.source._value;
  //       this.AllSubfilter.push({ column: 'Sub_LOB', value: newevent.source._value, index: element['id'] });
  //     } else {
  //       this.SubLobFilter = [];
  //     }
  //     this.trigger.toArray()[2].openMenu();
  //   }

  //   if (column.key == 'ChiefArchitect') {
  //     this.AllSubfilter.forEach((a, i) => {
  //       if (a.column == 'ChiefArchitect') this.AllSubfilter.splice(i, 1);
  //     });
  //     newevent = this.checkPrevious(event,this.ChiefArchitectFilter);
  //     if (newevent.source._value.length > 0) {
  //       this.ChiefArchitectFilter = newevent.source._value;
  //       this.AllSubfilter.push({ column: 'ChiefArchitect', value: newevent.source._value, index: element['id'] });
  //     } else {
  //       this.ChiefArchitectFilter = [];
  //     }
  //     this.trigger.toArray()[3].openMenu();
  //   }

  //   if (column.key == 'ArchitectDelegate') {
  //     this.AllSubfilter.forEach((a, i) => {
  //       if (a.column == 'ArchitectDelegate') this.AllSubfilter.splice(i, 1);
  //     });
  //     newevent = this.checkPrevious(event,this.ArchitectDelegateFilter);
  //     if (newevent.source._value.length > 0) {
  //       this.ArchitectDelegateFilter = newevent.source._value;
  //       this.AllSubfilter.push({ column: 'ArchitectDelegate', value: newevent.source._value, index: element['id'] });
  //     } else {
  //       this.ArchitectDelegateFilter = [];
  //     }
  //     this.trigger.toArray()[4].openMenu();
  //   }
  //   if (column.key == 'role') {
  //     this.AllSubfilter.forEach((a, i) => {
  //       if (a.column == 'role') this.AllSubfilter.splice(i, 1);
  //     });
  //     newevent = this.checkPrevious(event,this.RoleFilter);
  //     if (newevent.source._value.length > 0) {
  //       this.RoleFilter = newevent.source._value;
  //       this.AllSubfilter.push({ column: 'role', value: newevent.source._value, index: element['id'] });
  //     } else {
  //       this.RoleFilter = [];
  //     }
  //     this.trigger.toArray()[3].openMenu();
  //   }
  //   if (column.key == 'Users') {
  //     this.AllSubfilter.forEach((a, i) => {
  //       if (a.column == 'Users') this.AllSubfilter.splice(i, 1);
  //     });
  //     newevent = this.checkPrevious(event,this.NameFilter);
  //     if (newevent.source._value.length > 0) {
  //       this.NameFilter = newevent.source._value;
  //       this.AllSubfilter.push({ column: 'Users', value: newevent.source._value, index: element['id'] });
  //     } else {
  //       this.NameFilter = [];
  //     }
  //     this.trigger.toArray()[4].openMenu();
  //   }

  // }

  selectionSubChange(event, column, element) {
    if (!column) {
      return;
    }

    const resolvedElement = this.resolveSubFilterParentRow(element);
    if (!resolvedElement) {
      return;
    }
    
    switch (column.key) {
      case 'SubLineofBusiness':
      case 'Sub_LOB':
        this.updateSubFilter(event, column, resolvedElement, this.SubLobFilter, 2);
        break;

      case 'Year':
        this.updateSubFilter(event, column, resolvedElement, this.SubYearFilter, 2);
        break;
  
      case 'ChiefArchitect':
        this.updateSubFilter(event, column, resolvedElement, this.ChiefArchitectFilter, 3);
        break;

      case 'ArchitectDelegate':
        this.updateSubFilter(event, column, resolvedElement, this.ArchitectDelegateFilter, 4);
        break;

      case 'role':
        this.updateSubFilter(event, column, resolvedElement, this.RoleFilter, 3);
        break;

      case 'Users':
        this.updateSubFilter(event, column, resolvedElement, this.NameFilter, 4);
        break;

    }
  }



  private updateSubFilter(event, column, element, filterArray, triggerIndex) {
    if (!event || !event.source || !column || !element) {
      return;
    }

    const elementId = element['id'];
    if (elementId === undefined || elementId === null) {
      return;
    }

    this.removeExistingSubFilter(column, element);
    const newevent = this.checkPrevious(event, filterArray);
    
    // Update the actual class property based on column key
    if (newevent.source._value.length > 0) {
      const filterValue = newevent.source._value;
      this.AllSubfilter.push({ column: column.key, value: filterValue, index: elementId });
      
      // Update the corresponding filter array property
      switch (column.key) {
        case 'SubLineofBusiness':
        case 'Sub_LOB':
          this.SubLobFilter = filterValue;
          break;
        case 'Year':
          this.SubYearFilter = filterValue;
          break;
        case 'ChiefArchitect':
          this.ChiefArchitectFilter = filterValue;
          break;
        case 'ArchitectDelegate':
          this.ArchitectDelegateFilter = filterValue;
          break;
        case 'role':
          this.RoleFilter = filterValue;
          break;
        case 'Users':
          this.NameFilter = filterValue;
          break;
      }
    } else {
      // Clear the corresponding filter array property
      switch (column.key) {
        case 'SubLineofBusiness':
        case 'Sub_LOB':
          this.SubLobFilter = [];
          break;
        case 'Year':
          this.SubYearFilter = [];
          break;
        case 'ChiefArchitect':
          this.ChiefArchitectFilter = [];
          break;
        case 'ArchitectDelegate':
          this.ArchitectDelegateFilter = [];
          break;
        case 'role':
          this.RoleFilter = [];
          break;
        case 'Users':
          this.NameFilter = [];
          break;
      }
    }
    // this.trigger.toArray()[triggerIndex].openMenu();
  }

  private removeExistingSubFilter(column, element) {
    if (!column || !element) {
      return;
    }

    const elementId = element['id'];
    if (elementId === undefined || elementId === null) {
      return;
    }

    this.AllSubfilter = this.AllSubfilter.filter(
      a => !(a.column === column.key && elementId === a.index)
    );
  }

  private resolveSubFilterParentRow(element: any) {
    if (element && element.childDataSource) {
      return element;
    }

    if (Array.isArray(this.olddatasource) && Number.isInteger(this.selectedChildTableIndex)) {
      const byIndex = this.olddatasource[this.selectedChildTableIndex];
      if (byIndex && byIndex.childDataSource) {
        return byIndex;
      }
    }

    if (Array.isArray(this.olddatasource) && element && element['id'] !== undefined && element['id'] !== null) {
      const byId = this.olddatasource.find(item => item && item['id'] === element['id']);
      if (byId) {
        return byId;
      }
    }

    return null;
  }

  private getOriginalSubRows(element: any) {
    if (!element) {
      return [];
    }

    if (Array.isArray(element['sublob'])) {
      return element['sublob'];
    }

    if (Array.isArray(element['subLob'])) {
      return element['subLob'];
    }

    return [];
  }


  applyLocalFilter() {
    this.resetSearch();
    let filterdata = this.olddatasource;
    this.Allfilter.forEach(e1 => {
      const index = this.coltofilter.findIndex(x => x.key === e1.column);
      if (e1.value.length > 0) {
        filterdata = this.applyFilterForColumn(e1, filterdata, index);
      }
    });

    this.updateDataSource(filterdata);
    this.closeAllMenus();
    // Emit the filtered data count
    this.filteredDataCountEvent.emit(filterdata.length);
  }

  private resetSearch() {
    this.searchTxt = '';
    this.previousSelection = [];
  }

  private applyFilterForColumn(e1, filterdata, index) {
    switch (e1.column) {
      case 'MasterSegment':
      case 'Master_Segment':
        return this.filterByColumn(e1, filterdata, index, 'SegmentFilterApplied');
      case 'DecomLobID':
        return this.filterByColumn(e1, filterdata, index, 'decomIdFilterApplied');
      case 'MBO_Segment':
        return this.filterByColumn(e1, filterdata, index, 'SegmentFilterApplied');
      case 'Sub_LOB':
        return this.filterByColumn(e1, filterdata, index, 'sblobFilterApplied');
      case 'MBO_Segment_ID':
        return this.filterByColumn(e1, filterdata, index, 'decomIdFilterApplied');
      case 'DecomLobName':
        return this.filterByColumn(e1, filterdata, index, 'decomFilterApplied');
      case 'displayName':
        return this.filterByColumn(e1, filterdata, index, 'isNameFilterApplied');
      case 'Size':
        return this.filterByColumn(e1, filterdata, index, 'sizeFilterApplied');
      case 'CIOLOB':
      case 'lob':
        return this.filterByColumn(e1, filterdata, index, 'LobFilterApplied');
      case 'User_Role':
        return this.filterByColumn(e1, filterdata, index, 'userRoleFilterApplied');
      case 'MULTI_SRV':
        return this.filterByColumn(e1, filterdata, index, 'multiSRVFilterApplied');
      case 'year':
        return this.filterByColumn(e1, filterdata, index, 'yearFilterApplied');
      case 'SRVDESC':
        return this.filterByColumn(e1, filterdata, index, 'serviceFilterApplied');
      case 'Category':
        return this.filterByColumn(e1, filterdata, index, 'categoryFilterApplied');
      case 'Service':
        return this.filterByColumn(e1, filterdata, index, 'serviceKeyFilterApplied');
      case 'Public_Private_Cloud':
        return this.filterByColumn(e1, filterdata, index, 'Public_Private_CloudFilterApplied');
      case 'Edit_TOH':
        return this.filterByColumn(e1, filterdata, index, 'Edit_TOHFilterApplied');
      case 'SRV_Disable':
        return this.filterByColumn(e1, filterdata, index, 'SRV_DisableFilterApplied');
      case 'Complex_Services':
        return this.filterByColumn(e1, filterdata, index, 'Complex_ServicesFilterApplied');
      case 'UI_Comments':
        return this.filterByColumn(e1, filterdata, index, 'UI_CommentsFilterApplied');
      case 'App_NonApp':
        return this.filterByColumn(e1, filterdata, index, 'App_NonAppFilterApplied');
      case 'Users':
        return this.filterByColumn(e1, filterdata, index, 'usersFilterApplied', true, 'Service_Owner_Name');
      case 'Feature':
        return this.filterByColumn(e1, filterdata, index, 'FeatureFilterApplied');
      case 'Role':
        return this.filterByColumn(e1, filterdata, index, 'RoleAccessFilterApplied');
      case 'Secure_Group':
        return this.filterByColumn(e1, filterdata, index, 'SecureGroupFilterApplied');
      default:
        return filterdata;
    }
  }

  private filterByColumn(e1, filterdata, index, filterFlag, isArray: boolean = false, arr_Key:string = '') {
    const column = this.coltofilter.find(x => x.key === e1.column);
    if(isArray){
      filterdata = filterdata.filter(item => e1.value.some(e => item[arr_Key] && item[arr_Key].includes(e)));
      this.filterList = filterdata.map(item => item[e1.column]);
    }else if (column?.type === 'date') {
      filterdata = filterdata.filter(item =>
        e1.value.some(e => e == this.getDateFilterDisplayText(item[e1.column], column))
      );
      this.filterLists = filterdata.map(item => this.getDateFilterDisplayText(item[e1.column], column));
    }else{
      filterdata = filterdata.filter(item => e1.value.some(e => e == item[e1.column]));
      this.filterLists = filterdata.map(item => item[e1.column]);
    }
    this[filterFlag] = true;
    this.dataSource = new MatTableDataSource(filterdata);
    this.dataSource.paginator = this.TABLE_CONFIG?.serverSidePagination ? undefined : this.paginator;
    this.dataSource.sort = this.sort;
    this.trigger.toArray()[index].closeMenu();
    return filterdata;
  }

  private updateDataSource(_filterdata) {
    if (this.Allfilter.length == 0) {
      this.dataSource = new MatTableDataSource(this.olddatasource);
    }
    this.dataSource.paginator = this.TABLE_CONFIG?.serverSidePagination ? undefined : this.paginator;
    this.dataSource.sort = this.sort;
  }



  private updateSortOnDataSource() {
    if (this.dataSource && this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  private closeAllMenus() {
    this.coltofilter.forEach((_col, i) => {
      if (this.trigger.toArray()[i]) {
        this.trigger.toArray()[i].closeMenu();
      }
    });
  }

  applySubLocalFilter(_column, element) {
    element = this.resolveSubFilterParentRow(element);
    if (!element || !element.childDataSource) {
      return;
    }

    const elementId = element['id'];
    if (elementId === undefined || elementId === null) {
      return;
    }

    this.searchSubTxt = '';
    let filterdata = element.childDataSource.data;
    let count = 0;

    this.AllSubfilter.forEach(e1 => {
      if (e1.column == 'SubLineofBusiness' && elementId == e1.index) {
        if (e1.value.length > 0) {
          count += 1;
          filterdata = filterdata.filter(item => e1.value.some(e => e == item.SubLineofBusiness));
          this.filterLists = filterdata.map(item => {
            return item.SubLineofBusiness;
          });
          this.SubLobFilterApplied[elementId] = true;
          element.childDataSource = new MatTableDataSource(filterdata);
          element.childDataSource.paginator = this.childpaginator.toArray()[0];
          element.childDataSource.sort = this.sort;
          this.trigger.toArray()[2].closeMenu();
        }
      }
      if (e1.column == 'Year' && elementId == e1.index) {
        if (e1.value.length > 0) {
          count += 1;
          filterdata = filterdata.filter(item => e1.value.some(e => e == item.Year));
          this.filterLists = filterdata.map(item => {
            return item.Year;
          });
          this.subYearFilterApplied[elementId] = true;
          element.childDataSource = new MatTableDataSource(filterdata);
          element.childDataSource.paginator = this.childpaginator.toArray()[0];
          element.childDataSource.sort = this.sort;
          console.log(this.trigger.toArray())
          this.trigger.toArray()[2].closeMenu();
        }
      }
      if (e1.column == 'Sub_LOB' && elementId == e1.index) {
        if (e1.value.length > 0) {
          count += 1;
          filterdata = filterdata.filter(item => e1.value.some(e => e == item.Sub_LOB));
          this.filterLists = filterdata.map(item => {
            return item.Sub_LOB;
          });
          this.SubLobFilterApplied[elementId] = true;
          element.childDataSource = new MatTableDataSource(filterdata);
          element.childDataSource.paginator = this.childpaginator.toArray()[0];
          element.childDataSource.sort = this.sort;
          this.trigger.toArray()[2].closeMenu();
        }
      }
      if (e1.column == 'role' && elementId == e1.index) {
        if (e1.value.length > 0) {
          count += 1;
          filterdata = filterdata.filter(item => e1.value.some(e => e == item.role));
          this.filterLists = filterdata.map(item => {
            return item.role;
          });
          this.RoleFilterApplied[elementId] = true;
          element.childDataSource = new MatTableDataSource(filterdata);
          element.childDataSource.paginator = this.childpaginator.toArray()[0];
          element.childDataSource.sort = this.sort;
          this.trigger.toArray()[3].closeMenu();
        }
      }
      if (e1.column == 'Users' && elementId == e1.index) {
        if (e1.value.length > 0) {
          count += 1;
          filterdata = filterdata.filter(item =>
            e1.value.some(e => {
              if (item.Users.includes(e)) {
                return true;
              }
            })
          );
          filterdata.map(item => {
            item.Users.forEach(element => {
              this.filterLists.push(element);
            });
          });
          this.NameFilterApplied[elementId] = true;
          element.childDataSource = new MatTableDataSource(filterdata);
          element.childDataSource.paginator = this.childpaginator.toArray()[0];
          element.childDataSource.sort = this.sort;
          this.trigger.toArray()[4].closeMenu();
        }
      }
      if (e1.column == 'ChiefArchitect' && elementId == e1.index) {
        if (e1.value.length > 0) {
          count += 1;
          filterdata = filterdata.filter(item =>
            e1.value.some(e => {
              if (item.ChiefArchitectLabel.includes(e)) {
                return true;
              }
            })
          );
          filterdata.map(item => {
            item.ChiefArchitectLabel.forEach(element => {
              this.filterLists.push(element);
            });
          });
          this.ChiefArchitectFilterApplied[elementId] = true;
          element.childDataSource = new MatTableDataSource(filterdata);
          element.childDataSource.paginator = this.childpaginator.toArray()[0];
          element.childDataSource.sort = this.sort;
          this.trigger.toArray()[3].closeMenu();
        }
      }
      if (e1.column == 'ArchitectDelegate' && elementId == e1.index) {
        if (e1.value.length > 0) {
          count += 1;
          filterdata = filterdata.filter(item =>
            e1.value.some(e => {
              if (item.ArchitectDelegateLabel.includes(e)) {
                return true;
              }
            })
          );
          filterdata.map(item => {
            item.ArchitectDelegateLabel.forEach(element => {
              this.filterLists.push(element);
            });
          });
          this.ArchitectDelegateFilterApplied[elementId] = true;
          element.childDataSource = new MatTableDataSource(filterdata);
          element.childDataSource.paginator = this.childpaginator.toArray()[0];
          element.childDataSource.sort = this.sort;
          this.trigger.toArray()[4].closeMenu();
        }
      }
    });
    if (count == 0) {
      if(this.currentFilterColumn && this.currentFilterColumn.key == 'Year'){
        element.childDataSource = new MatTableDataSource(element.service_year_list);
      }else{
      element.childDataSource = new MatTableDataSource(this.getOriginalSubRows(element));
      }
      element.childDataSource.paginator = this.childpaginator.toArray()[0];
      element.childDataSource.sort = this.sort;
    }
    if (this.AllSubfilter.length == 0) {
      if(this.currentFilterColumn && this.currentFilterColumn.key == 'Year'){
        element.childDataSource = new MatTableDataSource(element.service_year_list);
      }else{
        element.childDataSource = new MatTableDataSource(this.getOriginalSubRows(element));
      }
      element.childDataSource.paginator = this.childpaginator.toArray()[0];
      element.childDataSource.sort = this.sort;
    }
    if (this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if (this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }
    if (this.trigger.toArray()[4]) {
      this.trigger.toArray()[4].closeMenu();
    }
  }

  clearLocalFilter(column) {
    this.searchTxt = '';
    this.previousSelection = [];
    this.coltofilter.forEach((_col, i) => {
      if (this.trigger.toArray()[i]) {
        this.trigger.toArray()[i].closeMenu();
      }
    });

    if (column.key == 'MBO_Segment' || column.key == 'MasterSegment' || column.key == "Master_Segment") {
      this.SegmentFilter = [];
      this.SegmentFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'MBO_Segment' || a.column == 'MasterSegment' || a.column == 'Master_Segment') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'MBO_Segment_ID' || column.key == 'DecomLobID') {
      this.decomIdFilter = [];
      this.decomIdFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'MBO_Segment_ID' || a.column == 'DecomLobID') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'DecomLobName' || column.key == "DecomLobName") {
      this.decomFilter = [];
      this.decomFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'DecomLobName' || a.column == 'DecomLobName') this.Allfilter.splice(i, 1);
      });
    }

    if (column.key == 'CIOLOB') {
      this.LobFilter = [];
      this.LobFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'CIOLOB') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'User_Role') {
      this.userRoleFilter = [];
      this.userRoleFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'User_Role') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'lob') {
      this.LobFilter = [];
      this.LobFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'lob') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'User_Role') {
      this.LobFilter = [];
      this.userRoleFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'User_Role') this.Allfilter.splice(i, 1);
      });
    }

    if (column.key == 'Sub_LOB') {
      this.sblobFilter = [];
      this.sblobFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Sub_LOB') this.Allfilter.splice(i, 1);
      });
    }

    if (column.key == 'displayName') {
      this.userNameFilter = [];
      this.isNameFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'displayName') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'Size') {
      this.sizeFilter = [];
      this.sizeFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Size') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'MULTI_SRV') {
      this.multiSRVFilter = [];
      this.multiSRVFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'MULTI_SRV') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'year') {
      this.yearFilter = [];
      this.yearFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'year') this.Allfilter.splice(i, 1);
      });
    }
    if(column.key == 'Users') {
      this.usersFilter = [];
      this.usersFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Users') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'SRVDESC') {
      this.serviceFilter = [];
      this.serviceFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'SRVDESC') this.Allfilter.splice(i, 1);
      });
    }
    if (column.key == 'Service') {
      this.serviceKeyFilter = [];
      this.serviceKeyFilterApplied = false;
      this.Allfilter.forEach((a, i) => {
        if (a.column == 'Service') this.Allfilter.splice(i, 1);
      });
    }
    if(column.key == 'Category'){
      this.categoryFilter = [];
      this.categoryFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'Category') this.Allfilter.splice(i,1);
      })
    }
    if(column.key == 'SRV_Disable'){
      this.SRV_DisableFilter = [];
      this.SRV_DisableFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'SRV_Disable') this.Allfilter.splice(i,1);
      })
    }
    if(column.key == 'Public_Private_Cloud'){
      this.Public_Private_CloudFilter = [];
      this.Public_Private_CloudFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'Public_Private_Cloud') this.Allfilter.splice(i,1);
      })
    }
    if(column.key == 'Complex_Services'){
      this.Complex_ServicesFilter = [];
      this.Complex_ServicesFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'Complex_Services') this.Allfilter.splice(i,1);
      })
    }
    if(column.key == 'UI_Comments'){
      this.UI_CommentsFilter = [];
      this.UI_CommentsFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'UI_Comments') this.Allfilter.splice(i,1);
      })
    }
    if(column.key == 'App_NonApp'){
      this.App_NonAppFilter = [];
      this.App_NonAppFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'App_NonApp') this.Allfilter.splice(i,1);
      });
    }
    if(column.key == 'Edit_TOH'){
      this.Edit_TOHFilter = [];
      this.Edit_TOHFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'Edit_TOH') this.Allfilter.splice(i,1);
      })
    }
    if(column.key == 'Feature'){
      this.FeatureFilter = [];
      this.FeatureFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'Feature') this.Allfilter.splice(i,1);
      })
    }
    if(column.key == 'Role'){
      this.RoleAccessFilter = [];
      this.RoleAccessFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'Role') this.Allfilter.splice(i,1);
      })
    }
    if(column.key == 'Secure_Group'){
      this.SecureGroupFilter = [];
      this.SecureGroupFilterApplied = false;
      this.Allfilter.forEach((a,i)=>{
        if(a.column == 'Secure_Group') this.Allfilter.splice(i,1);
      })
    }

    this.applyLocalFilter();
  }
  clearSubLocalFilter(column, element) {
    element = this.resolveSubFilterParentRow(element);
    if (!column || !element) {
      return;
    }

    const elementId = element['id'];
    if (elementId === undefined || elementId === null) {
      return;
    }

    this.searchSubTxt = '';
    this.previousSelection = [];
    if (this.trigger.toArray()[0]) {
      this.trigger.toArray()[0].closeMenu();
    }
    if (this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if (this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if (this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }
    if (this.trigger.toArray()[4]) {
      this.trigger.toArray()[4].closeMenu();
    }

    if (column.key == 'SubLineofBusiness') {
      this.SubLobFilter = [];
      this.SubLobFilterApplied[elementId] = false;
      this.AllSubfilter.forEach((a, i) => {
        if (a.column == 'SubLineofBusiness' && elementId == a.index) this.AllSubfilter.splice(i, 1);
      });
    }
    if (column.key == 'Year') {
      this.SubYearFilter = [];
      this.subYearFilterApplied[elementId] = false;
      this.AllSubfilter.forEach((a, i) => {
        if (a.column == 'Year' && elementId == a.index) this.AllSubfilter.splice(i, 1);
      });
    }
    if (column.key == 'Sub_LOB') {
      this.SubLobFilter = [];
      this.SubLobFilterApplied[elementId] = false;
      this.AllSubfilter.forEach((a, i) => {
        if (a.column == 'Sub_LOB' && elementId == a.index) this.AllSubfilter.splice(i, 1);
      });
    }
    if (column.key == 'ChiefArchitect') {
      this.ChiefArchitectFilter = [];
      this.ChiefArchitectFilterApplied[elementId] = false;
      this.AllSubfilter.forEach((a, i) => {
        if (a.column == 'ChiefArchitect' && elementId == a.index) this.AllSubfilter.splice(i, 1);
      });
    }
    if (column.key == 'ArchitectDelegate') {
      this.ArchitectDelegateFilter = [];
      this.ArchitectDelegateFilterApplied[elementId] = false;
      this.AllSubfilter.forEach((a, i) => {
        if (a.column == 'ArchitectDelegate' && elementId == a.index) this.AllSubfilter.splice(i, 1);
      });
    }
    if (column.key == 'Users') {
      this.NameFilter = [];
      this.NameFilterApplied[elementId] = false;
      this.AllSubfilter.forEach((a, i) => {
        if (a.column == 'Users' && elementId == a.index) this.AllSubfilter.splice(i, 1);
      });
    }
    if (column.key == 'role') {
      this.RoleFilter = [];
      this.RoleFilterApplied[elementId] = false;
      this.AllSubfilter.forEach((a, i) => {
        if (a.column == 'role' && elementId == a.index) this.AllSubfilter.splice(i, 1);
      });
    }

    this.applySubLocalFilter(column, element);
  }

  clearallSubFilter(element, sublistName = '') {
    this.trigger.toArray()[0].closeMenu();
    if (this.trigger.toArray()[1]) {
      this.trigger.toArray()[1].closeMenu();
    }
    if (this.trigger.toArray()[2]) {
      this.trigger.toArray()[2].closeMenu();
    }
    if (this.trigger.toArray()[3]) {
      this.trigger.toArray()[3].closeMenu();
    }
    if (this.trigger.toArray()[4]) {
      this.trigger.toArray()[4].closeMenu();
    }
    this.SubLobFilterApplied[element['id']] = false;
    this.subYearFilterApplied[element['id']] = false;
    this.ChiefArchitectFilterApplied[element['id']] = false;
    this.ArchitectDelegateFilterApplied[element['id']] = false;
    this.NameFilterApplied[element['id']] = false;
    this.RoleFilterApplied[element['id']] = false;
    this.AllSubfilter.map(e1 => {
      if (e1.index != element['id']) return true;
    });
    this.AllSubfilter = [];
    this.SubLobFilter = [];
    this.ChiefArchitectFilter = [];
    this.SubYearFilter = [];
    this.ArchitectDelegateFilter = [];
    this.NameFilter = [];
    this.RoleFilter = [];
    if(sublistName){
      const list = element[sublistName];
      element.childDataSource = new MatTableDataSource(list);
    }else{
      element.childDataSource = this.olddatasource[element['id']]['sublob'] ? new MatTableDataSource(this.olddatasource[element['id']]['sublob']) : new MatTableDataSource(this.olddatasource[element['id']]['subLob']);
    }
    element.childDataSource.paginator = this.childpaginator.toArray()[0];
    element.childDataSource.sort = this.sort;
  }

  clearallFilter(isDataSourceRegenarted = true) {
    this.coltofilter.forEach((_col, i) => {
      if (this.trigger.toArray()[i]) {
        this.trigger.toArray()[i].closeMenu();
      }
    });
    this.SegmentFilterApplied = false;
    this.decomFilterApplied = false;
    this.decomIdFilterApplied = false;
    this.LobFilterApplied = false;
    this.userRoleFilterApplied = false;
    this.sblobFilterApplied = false;
    this.isNameFilterApplied = false;
    this.sizeFilterApplied = false;
    this.multiSRVFilterApplied = false;
    this.yearFilterApplied = false;
    this.usersFilterApplied = false;
    this.serviceFilterApplied = false;
    this.serviceKeyFilterApplied = false;
    this.categoryFilterApplied = false;
    this.SRV_DisableFilterApplied = false;
    this.Public_Private_CloudFilterApplied = false;
    this.Complex_ServicesFilterApplied = false;
    this.UI_CommentsFilterApplied = false;
    this.App_NonAppFilterApplied = false;
    this.Edit_TOHFilterApplied = false;
    this.FeatureFilterApplied = false;
    this.RoleAccessFilterApplied = false;
    this.SecureGroupFilterApplied = false;
    this.sblobFilter = [];
    this.userNameFilter = [];
    this.sizeFilter = [];
    this.Allfilter = [];
    this.SegmentFilter = [];
    this.decomIdFilter = [];
    this.decomFilter = [];
    this.userRoleFilter = [];
    this.LobFilter = [];
    this.RoleFilter = [];
    this.NameFilter = [];
    this.serviceFilter = [];
    this.serviceKeyFilter = [];
    this.categoryFilter = [];
    this.SRV_DisableFilter = [];
    this.Public_Private_CloudFilter = [];
    this.Complex_ServicesFilter = [];
    this.UI_CommentsFilter = [];
    this.App_NonAppFilter = [];
    this.Edit_TOHFilter = [];
    this.multiSRVFilter = [];
    this.yearFilter = [];
    this.usersFilter = [];
    this.FeatureFilter = [];
    this.RoleAccessFilter = [];
    this.SecureGroupFilter = [];
    if (isDataSourceRegenarted) {
      this.dataSource = new MatTableDataSource(this.olddatasource);
      this.dataSource.data.forEach(element => {
        element.expand = false;
      });
      this.dataSource = new MatTableDataSource(this.dataSource.data);
      this.dataSource.paginator = this.TABLE_CONFIG?.serverSidePagination ? undefined : this.paginator;
      this.dataSource.sort = this.sort;
      // Emit the full data count when filters are cleared
      this.filteredDataCountEvent.emit(this.olddatasource.length);
    }
  }

  filterLists: any = [];
  

  filterSubDropdown(element, column, parentIndex?: number) {
    // Store the current column for use in the menu
    this.currentFilterColumn = column;
    // Use parentIndex if provided, otherwise fall back to element['id']
    if(column.key == 'Year'){
      this.selectedChildTableIndex = parentIndex;
    }else{
      this.selectedChildTableIndex = element['id'];
    }
    const filteredSubYear = this.AllSubfilter.filter(val => val.index == element['id']);
    
    // Prepare filter list based on column type - menu will open automatically via [matMenuTriggerFor]
    if (column.key == 'SubLineofBusiness' || column.labelKey == 'SubLineofBusiness') {
      this.filterList = element.childDataSource.data.map(item => {
        return item[column.key];
      });
      if (filteredSubYear.length > 0) {
        this.filSubValue = filteredSubYear[0].value;
      }else{
        this.filSubValue = [];
        this.SubLobFilter = [];
      }
    }
    else if (column.key == 'Year') {
      this.filterList = element.childDataSource.data.map(item => {
        return item[column.key];
      });
      if (filteredSubYear.length > 0) {
        this.filSubValue = filteredSubYear[0].value;
      }else{
        this.filSubValue = [];
        this.SubYearFilter = [];
      }
      
    }
    else if (column.key == 'role') {
      this.filterList = element.childDataSource.data.map(item => {
        return item[column.key];
      });
      if (filteredSubYear.length > 0) {
        this.filSubValue = filteredSubYear[0].value;
      }else{
        this.filSubValue = [];
        this.RoleFilter = [];
      }
    }
    else if (column.key == 'ChiefArchitect') {
      this.filterList = [];
      element.childDataSource.data.map(item => {
        item.ChiefArchitectLabel.forEach(element => {
          this.filterList.push(element);
        });
      });
      if (filteredSubYear.length > 0) {
        this.filSubValue = filteredSubYear[0].value;
      }else{
        this.filSubValue = [];
        this.ChiefArchitectFilter = [];
      }
    }
    else if (column.key == 'Users') {
      this.filterList = [];
      element.childDataSource.data.map(item => {
        item.Users.forEach(element => {
          this.filterList.push(element);
        });
      });
      if (filteredSubYear.length > 0) {
        this.filSubValue = filteredSubYear[0].value;
      }else{
        this.filSubValue = [];
        this.NameFilter = [];
      }
    }
    else if (column.key == 'ArchitectDelegate') {
      this.filterList = [];
      element.childDataSource.data.map(item => {
        item.ArchitectDelegateLabel.forEach(element => {
          this.filterList.push(element);
        });
      });
      if (filteredSubYear.length > 0) {
        this.filSubValue = filteredSubYear[0].value;
      }else{
        this.filSubValue = [];
        this.ArchitectDelegateFilter = [];
      }
    }

    this.filterList = new Set([...this.filterList]);
    this.filterLists = Array.from(this.filterList);
  }

  filterDropdown(column) {
    this.searchValue = '';
    const index = this.coltofilter.findIndex(x => x.key === column.key);
    this.trigger.toArray().forEach((item: MatMenuTrigger, i: number) => {
      if (i !== index && item.menuOpen) {
        item.closeMenu();
      }
    });

    if (column.key == 'MBO_Segment' || column.key == 'MasterSegment' || column.key == "Master_Segment") {
      this.filterList = this.dataSource.data.map(item => {
        return item[column.key];
      });
      this.filValue = this.SegmentFilter;
      console.log(this.filterList, "filList")
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'MBO_Segment_ID' || column.key == 'DecomLobID') {
      this.filterList = this.dataSource.data.map(item => {
        return item[column.key];
      });
      this.filValue = this.decomIdFilter;
      console.log(this.filterList, "filList")
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'DecomLobName') {
      this.filterList = this.dataSource.data.map(item => {
        return item[column.key];
      });
      console.log(this.filterList, "filList")
      this.filValue = this.decomFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'CIOLOB') {
      this.filterList = this.dataSource.data.map(item => {
        return item.CIOLOB;
      });
      this.filValue = this.LobFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'User_Role') {
      this.filterList = this.dataSource.data.map(item => {
        return item.User_Role;
      });
      this.filValue = this.userRoleFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'lob') {
      this.filterList = this.dataSource.data.map(item => {
        return item.lob;
      });
      this.filValue = this.LobFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'Sub_LOB') {
      this.filterList = this.dataSource.data.map(item => {
        return item.Sub_LOB;
      });
      this.filValue = this.sblobFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'displayName') {
      this.filterList = this.dataSource.data.map(item => {
        return item.displayName;
      });
      this.filValue = this.userNameFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'Size') {
      this.filterList = this.dataSource.data.map(item => {
        return item.Size;
      });
      this.filValue = this.sizeFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'MULTI_SRV') {
      this.filterList = this.dataSource.data.map(item => {
        return item.MULTI_SRV;
      });
      this.filValue = this.multiSRVFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'year') {
      this.filterList = this.dataSource.data.map(item => {
        return item.year;
      });
      this.filValue = this.yearFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'SRVDESC') {
      this.filterList = this.dataSource.data.map(item => {
        return item.SRVDESC;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.serviceFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if (column.key == 'Service') {
      this.filterList = this.dataSource.data.map(item => {
        return item.Service;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.serviceKeyFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'Category'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.Category;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.categoryFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'Public_Private_Cloud'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.Public_Private_Cloud;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.Public_Private_CloudFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'Complex_Services'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.Complex_Services;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.Complex_ServicesFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'UI_Comments'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.UI_Comments;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.UI_CommentsFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'App_NonApp'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.App_NonApp;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.App_NonAppFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'Edit_TOH'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.Edit_TOH;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.Edit_TOHFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'SRV_Disable'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.SRV_Disable;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.SRV_DisableFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'Users'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.Service_Owner_Name;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.usersFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'Feature'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.Feature;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.FeatureFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'Role'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.Role;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.RoleAccessFilter;
      this.trigger.toArray()[index].openMenu();
    }
    if(column.key == 'Secure_Group'){
      this.filterList = this.dataSource.data.map(item =>{
        return item.Secure_Group;
      }).filter(item => item != null && item != undefined && item != "");
      this.filValue = this.SecureGroupFilter;
      this.trigger.toArray()[index].openMenu();
    }

    this.filterList = new Set([...this.filterList]);
    if (column?.type === 'date') {
      this.filterList = new Set([...this.filterList].map(item => this.getDateFilterDisplayText(item, column)));
    }
    this.filterLists = Array.from(this.filterList);
  }
  search(query: string) {
    const result = this.select(query);
    this.filterLists = result;
  }
  select(query: string): string[] {
    const result: string[] = [];
    for (const a of this.filterList) {
      if (a.toLowerCase().indexOf(query) > -1) {
        result.push(a);
      }
    }
    return result;
  }

  private getDateFilterDisplayText(row: any, column: any): string {
    if (row === null || row === undefined) {
      return '';
    }

    const formattedDate = formatDate(row, column?.dateFormat || 'medium', 'en-US', column?.timeZone || undefined);
    return column?.timeZoneLabel ? `${formattedDate} ${column.timeZoneLabel}` : formattedDate;
  }

  checkAllRowsExpanded() {
    if (this.expandElements.length > 0) return false;
    else return true;
  }

  collapseDetailRow(element) {
    this.expandElements.forEach((ele, index) => {
      if (ele == element['id']) this.expandElements.splice(index, 1);
    });
    element.expand = false;
    if (this.checkAllRowsExpanded()) {
      this.collapseAllEvent(false);
    }
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  expandDetailRow(element, isExpand) {
    if (element && element['id'] >= 0) {
      if (element.details && element.details.length === 0) {
        return;
      }
      if (this.expandElements.indexOf(element['id'] == -1)) {
        this.expandElements.push(element['id']);
      }
      element.expand = isExpand;
      this.collapseAllEvent(true);
      this.expandedElement = this.expandedElement === element ? null : element;
      this.cd.detectChanges();

      this.innerTables.forEach((table, index) => {
        (table.dataSource as MatTableDataSource<any>).paginator = this.childpaginator.toArray()[index];
      });
    }
  }

  toggle() {
    this.dataSource.data.forEach(element => {
      element.expand = this.allRowsExpanded;
    });
    this.cd.detectChanges();
    this.innerTables.forEach((table, index) => {
      (table.dataSource as MatTableDataSource<any>).paginator = this.childpaginator.toArray()[index];
    });
  }
  isObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  exportToCsv() {
    if (!this.dataSource.data || !this.dataSource.data.length) {
      return;
    }
  
    const dataValues = [];
    this.dataSource.data.forEach(ele => {
      if (!ele['childDataSource']?.data) {
        return;
      }
      
      ele['childDataSource'].data.forEach(item => {
        const obj = this.buildExportRow(ele, item);
        dataValues.push(obj);
      });
    });
  
    const fileName = 'LOB - Maintenance';
    this.exportService.exportToExcel(fileName, [dataValues]);
  }
  
  private buildExportRow(parentElement: any, childItem: any): any {
    const obj: any = {};
    
    this.processParentColumns(obj, parentElement);
    this.processChildColumns(obj, childItem);
    
    return obj;
  }
  
  private processParentColumns(obj: any, element: any): void {
    this.COLUMNS.forEach((column: any) => {
      if (column.key === 'Actions' || column.key === 'subLobCount') {
        return;
      }
  
      if (column.key === 'MasterSegment') {
        this.processMasterSegmentColumn(obj, element, column);
      } else {
        this.processRegularParentColumn(obj, element, column);
      }
    });
  }
  
  private processMasterSegmentColumn(obj: any, element: any, column: any): void {
    obj[column['label']] = '';
    obj['Segment ID'] = '';
    
    if (element[column.key]) {
      obj[column['label']] = element[column.key];
      obj['Segment ID'] = element['SegID'];
    }
  }
  
  private processRegularParentColumn(obj: any, element: any, column: any): void {
    obj[column['label']] = '';
    
    if (!element[column.key]) {
      return;
    }
  
    if (Array.isArray(element[column.key])) {
      this.processArrayColumn(obj, element[column.key], column['label']);
    } else {
      obj[column['label']] = element[column.key];
    }
  }
  
  private processChildColumns(obj: any, item: any): void {
    // Use customColumns if available(dynamic sub table header), otherwise use expanded_columns
    const columnsToProcess = item.customColumns || this.expanded_columns;
    columnsToProcess.forEach((column: any) => {
      if (column.key === 'Actions') {
        this.addAuditFields(obj, item);
      } else {
        this.processRegularChildColumn(obj, item, column);
      }
    });
  }
  
  private processRegularChildColumn(obj: any, item: any, column: any): void {
    obj[column['label']] = '';
    
    if (!item[column.key]) {
      return;
    }
  
    if (Array.isArray(item[column.key])) {
      this.processArrayColumn(obj, item[column.key], column['label']);
    } else {
      obj[column['label']] = item[column.key];
    }
  }
  
  private processArrayColumn(obj: any, arrayData: any[], label: string): void {
    if (!arrayData.length || !this.isObject(arrayData[0])) {
      obj[label] = arrayData.join(', ');
      return;
    }
  
    const names = arrayData.map(ele => this.formatPersonName(ele));
    const msids = arrayData.map(ele => ele.msid);
    
    obj[label] = names.join(', ');
    obj[label + '_Msid'] = msids.join(', ');
  }
  
  private formatPersonName(person: any): string {
    if (person.middleName != null) {
      return `${person.sn} ${person.givenName} ${person.middleName}`;
    }
    return `${person.sn} ${person.givenName}`;
  }
  
  private addAuditFields(obj: any, item: any): void {
    obj['Created At'] = item['createdAt'];
    obj['Created By'] = item['createdByName'];
    obj['Updated At'] = item['updatedAt'];
    obj['Updated By'] = item['updatedByName'];
  }

  isAllSelected() {
    const hasHideCheckbox = this.dataSource.data.some(row => row.hideCheckbox);
    if (hasHideCheckbox) {
      const selectableRows = this.dataSource.data.filter(row => !row.hideCheckbox);
      const numSelected = this.selection.selected.filter(row =>
        this.dataSource.data.includes(row) && !row.hideCheckbox
      ).length;
      return selectableRows.length > 0 && numSelected === selectableRows.length;
    }
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Check if all rows in a child table are selected */
  isAllChildSelected(childDataSource: any) {
    if (!childDataSource || !childDataSource.data) return false;
    const childData = childDataSource.data;
    return childData.length > 0 && childData.every(row => this.selection.isSelected(row));
  }

  /** Check if some (but not all) rows in a child table are selected */
  isSomeChildSelected(childDataSource: any) {
    if (!childDataSource || !childDataSource.data) return false;
    const childData = childDataSource.data;
    const selectedCount = childData.filter(row => this.selection.isSelected(row)).length;
    return selectedCount > 0 && selectedCount < childData.length;
  }

  /** Toggle selection for all rows in a child table */
  masterToggleChild(childDataSource: any) {
    if (!childDataSource || !childDataSource.data) return;
    const childData = childDataSource.data;
    const params: any = {};
    
    if (this.isAllChildSelected(childDataSource)) {
      childData.forEach(row => this.selection.deselect(row));
      params['type'] = 'clearall';
    } else {
      childData.forEach(row => this.selection.select(row));
      params['type'] = 'selectall';
    }
    params['data'] = this.selection.selected;
    this.checkBoxEvent.emit(params);
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    const params: any = {};
    if (this.isAllSelected()) {
      this.selection.clear();
      params['type'] = 'clearall';
      params['data'] = this.selection.selected;
    } else {
      this.selection.select(...this.dataSource.data);
      params['type'] = 'selectall';
      params['data'] = this.selection.selected;
    }
    this.checkBoxEvent.emit(params);
  }

  selecttoggle() {
    const params: any = {};
    if (this.selection.selected.length > 0) {
      params['type'] = 'selectSpecific';
      params['data'] = this.selection.selected;
      this.checkClick.emit({ check: true, data: this.selection.selected });
    } else {
      params['type'] = 'unselect';
      params['data'] = this.selection.selected;
      this.checkClick.emit({ check: false, data: [] });
    }
    this.checkBoxEvent.emit(params);
  }

  cheskboxChanged(event, row) {
    if (event) this.selection.toggle(row);
    const params: any = {};
    params['type'] = 'singlecheck';
    params['checked'] = event.checked;
    params['row'] = row;
    params['data'] = this.selection.selected;
    this.checkBoxEvent.emit(params);
  }

  /** The label for the checkbox on the passed row */
  /**
   * Server side Pagination Starts
   */

  fetchMoreItems(event) {
    if (this.SORT_CONFIG) {
      event.sort = [[this.SORT_CONFIG.active, this.SORT_CONFIG.direction]];
    }
    this.paginationClickEvent.emit(event);
    return false;
  }

  sortData(event) {
    let sort: any[] = [];
    if (event.direction) {
      sort = [[event.active, event.direction]];
    }
    this.sortChangeEvent.emit(sort);
  }

  deleteRecord(element, index) {
    if (element && typeof element === 'object' && Number.isInteger(index)) {
      try {
        element.isEdit = false;
        this.selection.clear();

        if (element.isNew) {
          this.cancelEvent.emit(element);
          const data = this.dataSource.data.filter(ele => !ele['isNew']);
          this.dataSource = new MatTableDataSource(data);
          this.dataSource.paginator = this.paginator;
          this.leaderName = '';
          this.leaderMsid = '';
        } else {
          if (!element.leader_msid) {
            const result = this.findSelectedRowByIndex(index);
            this.selectedRow.find(item => item.i == index).isEdit = false;
            const findOrgIndex = this.dataSource.data.findIndex(i => i.org_id == result.org_id)
            this.dataSource.data[findOrgIndex] = this.selectedRow.find(obj => obj.org_id == element.org_id);
            this.dataSource.paginator = this.paginator;
          } else {
            this.selectedRow.find(item => item.i == index).isEdit = false;
            const rowVal = element;
            this.cancelEvent.emit(rowVal);
            const result = this.findSelectedRowByIndex(index);
            const findOrgIndex = this.dataSource.data.findIndex(obj => obj.leader_msid == result.leader_msid);
            this.dataSource.data[findOrgIndex] = this.selectedRow.find(obj => obj.leader_msid == element.leader_msid);
            this.dataSource.paginator = this.paginator;
          }

          this.selectedRow = this.selectedRow.filter(item => item.i !== index);
          this.cd.detectChanges();
        }
      } catch (error) {
        console.error('Error deleting record:', error);
      }
    } else {
      console.warn('Invalid input for deleteRecord');
    }
  }

  private findSelectedRowByIndex(index: number) {
    return this.selectedRow.find(item => item.i == index);
  }

  removeRecord(element) {
    this.removeRecordEvent.emit(element);
  }
  cancelRecord(element) {
    this.cancelRecordEvent.emit(element);
  }
  getDisableFlag(ele: any) {
    if (this.clonedData) {
      const org_data = this.clonedData.filter(e => e.org_id == ele.org_id);
      if (ele?.org_name == org_data[0]?.org_name)
        return true;
    }
    return false;
  }
  getDisableDelete(ele: any) {
    if (ele?.org_name == "")
      return true;
    else
      return false;
  }
  enableEditView(element, index) {
    element.isEdit = !element.isEdit;
    element.addsublob = false;
    if (typeof element['SubLineofBusiness'] != 'undefined') {
      if (!element['SubLineofBusiness'] || element['SubLineofBusiness'] == null) {
        element.addsublob = true;
      }
    }
    this.selectedRow.push(JSON.parse(JSON.stringify(element)));
    this.selectedRow[this.selectedRow.length - 1].i = index;
  }


  keyUpSearch(name) {
    const p: any = {};
    p['search'] = name.target.value;
    this.inputElement = name;
    if (name.target.value) {
      this.subject.next(p);
    } else {
      this.users = [];
    }
  }

  handleSearch(searchObj) {
    const value = searchObj['search'];
    const column = searchObj['column'];
    if (value) {
      this.capabilityService.getLDAPUsers(value).subscribe(
        dataStream => {
          this.users = [];
          dataStream.forEach(element => {
            this.users.push({
              givenName: element.givenName,
              sn: element.sn,
              mail: element.mail,
              displayName: element.displayName,
              employeeID: element.employeeID,
              msid: element.cn,
              middleName: element.middleName
            });
          });
        },
        error => {
          console.error(error);
        }
      );
    } else {
      column.options = [];
    }
  }

  saveRecord(element) {
    if (this.leaderName) {
      element.leader_name = this.leaderName;
      element.leader_msid = this.leaderMsid;
    }
  
    if (!this.validateRequiredFields(element)) {
      return false;
    }
  
    if (!this.validateLobMaintenance(element)) {
      return false;
    }
  
    this.saveEvent.emit(element);
    element.isEdit = !element.isEdit;
  }
  
  private validateRequiredFields(element: any): boolean {
    const validationsColumns = this.COLUMNS.filter(column => column.validations);
    const requiredColumns = this.getRequiredColumns(validationsColumns);
  
    if (!requiredColumns.length) {
      return true;
    }
  
    const missingData = this.getMissingRequiredData(element, requiredColumns);
  
    if (missingData.length) {
      const message = 'Please enter values for ' + missingData.join(', ');
      this.toastrService.error(message, '', { timeOut: 3000, positionClass: 'toast-top-center' });
      return false;
    }
  
    return true;
  }
  
  private getRequiredColumns(validationsColumns: any[]): any[] {
    return validationsColumns
      .map(column => {
        const req = column.validations.find(val => val.required === true);
        return req ? column : undefined;
      })
      .filter(res => res !== undefined);
  }
  
  private getMissingRequiredData(element: any, requiredColumns: any[]): string[] {
    const missingData: string[] = [];
  
    requiredColumns.forEach(col => {
      const labelKey = col.labelKey ? col.labelKey : col.key;
      
      if (!element[labelKey]) {
        missingData.push(col.label);
      } else if (!element.isNew && !element[col.key]) {
        missingData.push(col.label);
      }
    });
  
    return missingData;
  }
  
  private validateLobMaintenance(element: any): boolean {
    if (this.TABLE_CONFIG?.TABLE_CLASS !== 'lob-maintenance-tble-container') {
      return true;
    }
  
    if (element.isNew && element.org_name !== '') {
      return this.validateNewLobCombination(element);
    }
  
    return this.validateExistingLobData(element);
  }
  
  private validateNewLobCombination(element: any): boolean {
    const data = this.dataSource.data;
    const existingEntry = data.find(
      (ele: any) =>
        !ele.isNew &&
        ele.MasterSegment === element['SegID']['value'] &&
        ele.CIOLOB === element['LobID']['value'] &&
        ele.SubLineofBusiness === element['SubLobID']['value']
    );
  
    if (existingEntry) {
      const message = 'Segment/LOB/Sub LOB combination already exists, Please select other combination.';
      this.toastrService.error(message, '', { timeOut: 3000, positionClass: 'toast-top-center' });
      return false;
    }
  
    return true;
  }
  
  private validateExistingLobData(element: any): boolean {
    const masterFilters = this.dataFilter['MasterData'];
    const { loblist, subloblist } = this.extractLobLists(masterFilters);
  
    if (!this.validateLobName(element, loblist)) {
      return false;
    }
  
    if (!this.validateSubLobName(element, subloblist)) {
      return false;
    }
  
    return true;
  }
  
  private extractLobLists(masterFilters: any[]): { loblist: any[], subloblist: any[] } {
    const subloblist: any[] = [];
    
    const loblist = masterFilters.map(masele => {
      if (masele.subLob?.length) {
        masele.subLob.forEach(sube => {
          if (sube) {
            subloblist.push(sube);
          }
        });
      }
      return masele.lob;
    });
  
    return { loblist, subloblist };
  }
  
  private validateLobName(element: any, loblist: any[]): boolean {
    if (!element['CIOLOB']) {
      return true;
    }
  
    const lobResult = loblist.find(lobe => 
      lobe && lobe.toLowerCase() === element['CIOLOB'].toLowerCase()
    );
  
    if (!lobResult) {
      return true;
    }
  
    const lobFilterList = this.dataFilter['CIOLOB'];
    const matchingLob = lobFilterList.find(e => 
      e.value && e.value.toLowerCase() === element['CIOLOB'].toLowerCase()
    );
  
    if (matchingLob && matchingLob.key !== element['LobID']) {
      this.toastrService.error('LOB already exists, Please try with other name.', '', {
        timeOut: 3000,
        positionClass: 'toast-top-center'
      });
      return false;
    }
  
    return true;
  }
  
  private validateSubLobName(element: any, subloblist: any[]): boolean {
    if (!element['SubLineofBusiness']) {
      return true;
    }
  
    const sublobResult = subloblist.find(sub => 
      sub?.sub_lob && sub.sub_lob.toLowerCase() === element['SubLineofBusiness'].toLowerCase()
    );
  
    if (!sublobResult) {
      return true;
    }
  
    const sublobfilterlist = this.dataFilter['SubLineofBusiness'];
    const matchingSubLob = sublobfilterlist.find(e => 
      e.value && e.value.toLowerCase() === element['SubLineofBusiness'].toLowerCase()
    );
  
    if (matchingSubLob && matchingSubLob.key !== element['SubLobID']) {
      this.toastrService.error('Sub LOB already exists, Please try with other name.', '', {
        timeOut: 3000,
        positionClass: 'toast-top-center'
      });
      return false;
    }
  
    return true;
  }

  getFiltersList(col, from = '', record: any = '') {
    const dataFilter = from == 'filter' ? this.originalDataFilter : this.dataFilter;
    if (dataFilter && dataFilter[col.key]) {
      if (record) {
        if (['CIOLOB', 'SubLineofBusiness'].includes(col.key)) {
          if (!record['MasterSegment']) {
            return [];
          }
        }
        if (record.addsublob) {
          if (['SubLineofBusiness'].includes(col.key)) {
            return [];
          }
        }
        let options = dataFilter[col.key];
        options = options.sort((a, b) => (a['value'] < b['value'] ? -1 : 1));
        return options;
      }
      let options = dataFilter[col.key];
      options = options.sort((a, b) => (a['value'] < b['value'] ? -1 : 1));
      return options;
    }
    return [];
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our fruit

  }

  remove(option, element, col): void {
    if (element[col.key]) {
      const index = element[col.key].indexOf(option);
      if (index >= 0) {
        element[col.key].splice(index, 1);
      }
    }
  }

  selected(event: MatAutocompleteSelectedEvent, col, element): void {
    if (!element[col.key]) {
      element[col.key] = [];
    }
    const obj: any = {
      msid: event.option.value.key,
      givenName: event.option.value.givenName,
      sn: event.option.value.sn,
      employeeID: event.option.value.employeeID,
      mail: event.option.value.mail,
      middleName: event.option.value.middleName,
      displayName: event.option.value.displayName
    };
    element[col.key].push(obj);
    if (this.inputElement) {
      this.inputElement.target.value = '';
    }
    col.options = [];
  }

  getRequiredString(column) {
    if (column && column.validations) {
      const req = column.validations.filter(val => val.required);
      if (req) {
        return '*';
      }
    }
    return;
  }

  onChangeInputField(col: any, event, record) {
    if (event && event.value) {
      record[col['key']] = event.value.value;
      if (this.TABLE_CONFIG && this.TABLE_CONFIG.dependentFilters) {
        const dependents = this.TABLE_CONFIG.dependentFilters;
        const masterFilters = this.dataFilter['MasterData'];
        let masterSegment;
        let lobMatchingList;
        switch (col.key) {
          case 'MasterSegment':
            masterSegment = masterFilters.filter(ele => ele.master_segment == event.value.value);
            if (masterSegment && masterSegment.length) {
              const sublobList: any[] = [];
              const lobList = masterSegment.map(masele => {
                if (masele.subLob && masele.subLob.length) {
                  masele.subLob.map(sube => {
                    if (sube) {
                      sublobList.push(sube.sub_lob);
                    }
                  });
                }

                return masele.lob;
              });
              if (lobList && lobList.length) {
                const deps = dependents[col.key];
                deps.forEach(element => {
                  if (this.dataFilter[element] && element == 'CIOLOB') {
                    const uniquelob = [...new Set(lobList)];
                    const uniql = uniquelob.map(sube => {
                      const option: any = {};
                      option['key'] = sube;
                      option['value'] = sube;
                      option['disable'] = false;
                      return option;
                    });

                    this.dataFilter[element] = uniql;
                    record['LobID'] = '';
                  }
                  if (this.dataFilter[element] && element == 'SubLineofBusiness') {
                    const uniqueSublob = [...new Set(sublobList)];
                    uniqueSublob.map(sube => {
                      const option: any = {};
                      option['key'] = sube;
                      option['value'] = sube;
                      option['disable'] = false;
                      return option;
                    });

                    this.dataFilter[element] = []; //uniqsub
                    record['SubLobID'] = '';
                  }
                });
              }
            }
            break;

          case 'CIOLOB':
            lobMatchingList = masterFilters.filter(ele => ele.lob == event.value.value);
            if (lobMatchingList && lobMatchingList.length) {
              const sublobListInner: any[] = [];
              lobMatchingList.map(masele => {
                if (masele.subLob && masele.subLob.length) {
                  masele.subLob.map(sube => {
                    if (sube) {
                      sublobListInner.push(sube.sub_lob);
                    }
                  });
                }
              });
              if (sublobListInner.length) {
                const uniqueSublobInner = [...new Set(sublobListInner)];
                const uniqsubInner = uniqueSublobInner.map(sube => {
                  const option: any = {};
                  option['key'] = sube;
                  option['value'] = sube;
                  option['disable'] = false;
                  return option;
                });
                this.dataFilter['SubLineofBusiness'] = uniqsubInner;
                record['SubLobID'] = '';
              }
            }
            break;
        }
      }
    }
  }

  getNavigationLink(col, element) {
    switch (col.key) {
      case 'offeringId':
        return '/technology-insights?offeringId=' + element[col.key];
        break;
    }
  }

  createNew(col, element) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: 'Create New ' + col.label,
      Action_Type: 'Add_' + col.key,
      label: col.label,
      MasterData: this.dataFilter['MasterData']
    };
    dialogConfig.width = '35%';
    dialogConfig.hasBackdrop = true;
    dialogConfig.panelClass = 'maintenance-modal';
    dialogConfig.height = '40%';
    dialogConfig.disableClose = true;

    const dialogRef = this.dialog.open(MaintenanceModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.status == 'create') {
          result.element = element;
          this.CreateEvent.emit(result);
        }
      }
    });
  }

  openDeletePopup(element) {
    this.loadDeletePopup.emit(element);
  }

  loadEditSubLob(element) {
    console.log(element)
    this.columnDataSubLob.emit(element);
  }

  loadEditLob(lobData) {
    this.ColomnDataLob.emit(lobData);
  }

  collapseAllEvent(data) {
    this.collapseAll.emit(data);
  }

  editRole(roleElementData) {
    if(roleElementData && roleElementData.role){
      this.editRoleModel.show();
      this.editRoleData = { ...roleElementData };
    }
  }

  saveEditEvent(event) {
    const payload = {
      "add": (event?.add?.length) ? {
        "initiative_id": this.selectedInitiative?.initiative_ID,
        "role": event?.element?.role,
        "data": [
          {
            "lob": event?.element?.LobID,
            "sublob": [
              event?.element && event?.element?.subLobID
            ]
          }
        ],
        "names": event?.add
      } : {},
      "remove": (event?.remove?.length) ? {
        "initiative_id": this.selectedInitiative?.initiative_ID,
        "role": event?.element?.role,
        "data": [
          {
            "lob": event?.element?.LobID,
            "sublob": [
              event?.element && event?.element?.subLobID
            ]
          }
        ],
        "names": event?.remove
      } : {}
    }
    this.maintenanceService.updateEIRole(payload).subscribe(
      (response: any) => {
        this.showLoader = false;
        if (response && response.message && !response.status) {
          this.showSuccessMsg(response.message);
          this.editRoleModel.hide();
          this.notifyToParentInitiative.emit();
        } else if (response && response.status) {
          this.showErrMsg(response.status);
        }
      },
      err => {
        this.showLoader = false;
        this.showErrMsg(err);
      });

  }

  showErrMsg(err: any) {
    this.showLoader = false;
    if (err && err.message) {
      this.toastrService.error(err.message, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  showSuccessMsg(msg: any) {
    this.showLoader = false;
    if (msg) {
      this.toastrService.success(msg, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  // hidepopup() {
  //   this.editRoleData = {};
  // }
  alphaOrderLeadEAonDataSource(){
    // Function to apply alphabetical ordering to data source based on lead EA status
    try {
      if (this.dataSource.data === undefined || this.dataSource.data.length == 0) { return; }
      // Need to get into ChiefArchitect/ArchitectDelegate arrays in datasource.data[] -> childdatasource.data[], then sort them
      this.dataSource.data.forEach((arr) => {
        if (arr.childDataSource === undefined) { return; }
        arr.childDataSource.data.forEach((sublob_Arr) => {
          sublob_Arr.ChiefArchitect = this.alphaOrderLeadEA(sublob_Arr.ChiefArchitect)
          sublob_Arr.ArchitectDelegate = this.alphaOrderLeadEA(sublob_Arr.ArchitectDelegate)
        })
      });
    } catch (error) {
      console.error('Error processing data: (alphaOrderLeadEAonDataSource)', error);
    }
  }

  alphaOrderLeadEA(data: any): any {
    function getLastName(person) {
      return person.displayName.split(', ')[0];
    }
    // Function to sort architects by last name, prioritizing lead EAs placed before non lead EAs
    try {
      if (data === undefined || data.length === 0) { return []; }


      const leadEAs = data.filter(person => person.leadEA === 'Yes');
      const nonLeadEAs = data.filter(person => person.leadEA === 'No');

      leadEAs.sort((a, b) => getLastName(a).localeCompare(getLastName(b)));
      nonLeadEAs.sort((a, b) => getLastName(b).localeCompare(getLastName(a)));

      // Combine the lists with lead EAs at the front
      return [...leadEAs, ...nonLeadEAs];
    } catch (error) {
      console.error('Error processing data: (alphaOrderLeadEA)', error);
    }
  }

  updateStatus(element) {
    this.updateStatusEvent.emit(element);
  }

  sanitize(name: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(name);
  }

  // on Edit click
  onEditClick(element) {
    this.editEvent.emit(element);
  }

  isAddEditPopupOpen = false;

    private onModalClosed() {
      // any cleanup you need after modal closes
      this.isAddEditPopupOpen = false;
    }
  
  showAddEditPopup(type: string, element: any) {
    let arr = [];
    arr.push(element)
    this.decomSelectedEditRow = arr;
    this.addEditDecomLOBpopupType = type;
    this.isAddEditPopupOpen = true;
    this.modalAddLob.show();
  }

    private isHidingModal = false;

  hidepopup() {
    if (this.isHidingModal) {
      return;
    }
    this.isHidingModal = true;
    this.modalClosedSub?.unsubscribe();
    this.modalAddLob?.hide();
    setTimeout(() => {
      this.isHidingModal = false;
    }, 0);
  }

  respondToDecomApply(event){
    let msg = '';
    if (event.success) {
      if(event.type=== 'Add'){
        msg = 'Successfully added Segment';
      }
      if(event.type=== 'Update'){
        msg = 'Successfully updated Segment';
      }
      this.toaster.success(msg, '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      }); 
      console.log("should emit here")
      this.getLobMappingDetails.emit(); //refresh decom table
    } else {
      this.toaster.error('Internal Server Error.', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
    this.modalAddLob.hide();
  }
}
